// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"507":"privacyAgreement","890":"userAgreement"}[chunkId] + "." + {"507":"40f41e4c","890":"02bae338"}[chunkId] + ".css";
};